import React from 'react'
import { Route, Switch, Redirect,BrowserRouter } from 'react-router-dom'
import { setIOSConfigUrl } from 'utils/wechat/helper'
import config from "config/default"
import { HOME_PATH, THEME_PATH, COURSE_PATH, COVER_PATH, GRAPHIC_PATH, GENERALLIST_PATH, CLASSIFYLIST_PATH } from "./path"
import HomeRoute from "./home"
import ThemeRoute from "./theme"
import CourseRoute from "./course"
import CoverRoute from "./cover"
import GRAPHICRoute from "./graphic"
import GeneralListRoute from "./generalList"
import ClassifyListRoute from "./classifyList"

import './index.css'

const { subpath } = config

// 单独配置ios
setIOSConfigUrl()

export default function App() {
    return (
        <BrowserRouter basename={subpath}>
            <Switch>
                <Route exact path={HOME_PATH} component={HomeRoute} />
                <Route exact path={THEME_PATH()} component={ThemeRoute} />
                <Route exact path={COURSE_PATH()} component={CourseRoute} />
                <Route exact path={COVER_PATH()} component={CoverRoute} />
                <Route exact path={GRAPHIC_PATH()} component={GRAPHICRoute} />
                <Route exact path={GENERALLIST_PATH()} component={GeneralListRoute} />
                <Route exact path={CLASSIFYLIST_PATH()} component={ClassifyListRoute} />
                <Route render={() => <Redirect to={HOME_PATH} />} />
            </Switch>
        </BrowserRouter>
    )
}